import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import API, { formatApiError } from "@/lib/api";

export default function ChangePasswordPage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    if (newPassword.length < 6) return setError("New password must be at least 6 characters");
    if (newPassword === "changeme123") return setError("Choose a password other than the default password");
    if (newPassword !== confirmPassword) return setError("New passwords do not match");
    setSaving(true);
    try {
      await API.post("/auth/change-password", { current_password: "changeme123", new_password: newPassword });
      await logout();
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <form onSubmit={handleSubmit} className="w-full max-w-md bg-white border border-slate-200 rounded-sm p-8">
        <h1 className="text-2xl font-medium text-slate-950">Change your password</h1>
        <p className="mt-2 text-sm text-slate-500">Your account is using the default password. Set a new password, then sign in again.</p>
        <p className="mt-4 text-xs text-slate-500">{user?.email}</p>
        <div className="space-y-4 mt-6">
          <input data-testid="new-password-input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="New password" minLength={6} required className="border border-slate-200 rounded-sm px-3 py-2 w-full text-sm" />
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm new password" minLength={6} required className="border border-slate-200 rounded-sm px-3 py-2 w-full text-sm" />
        </div>
        {error && <div className="mt-4 bg-red-50 border border-red-200 text-red-700 text-sm px-3 py-2 rounded-sm">{error}</div>}
        <button type="submit" disabled={saving} className="mt-6 bg-[#002FA7] hover:bg-[#002480] text-white rounded-sm px-4 py-2.5 font-medium text-sm w-full">
          {saving ? "Saving..." : "Save password and sign out"}
        </button>
      </form>
    </div>
  );
}
